/* Search results page (nama-search.liquid): Clear toggle + Load more append. */
(function () {
  var root = document.querySelector('[data-nse]');
  if (!root) return;

  // Clear button visibility + action
  var form = root.querySelector('[data-nse-form]');
  var input = root.querySelector('[data-nse-input]');
  var clear = root.querySelector('[data-nse-clear]');
  if (input && clear && form) {
    function sync() { form.classList.toggle('has-value', input.value.trim().length > 0); }
    input.addEventListener('input', sync);
    clear.addEventListener('click', function () { input.value = ''; sync(); input.focus(); });
    sync();
  }

  // Load more — fetch the next page and append its cards
  var loadmore = root.querySelector('[data-nse-loadmore]');
  var grid = root.querySelector('[data-nse-grid]');
  var count = root.querySelector('[data-nse-count]');
  if (loadmore && grid) {
    loadmore.addEventListener('click', function (e) {
      e.preventDefault();
      if (loadmore.classList.contains('is-loading')) return;
      loadmore.classList.add('is-loading');
      fetch(loadmore.getAttribute('href'), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-nse-grid] .nse-card');
          newCards.forEach(function (c) { grid.appendChild(c); });
          var newCount = doc.querySelector('[data-nse-count]');
          if (newCount && count) count.textContent = newCount.textContent;
          var nextLink = doc.querySelector('[data-nse-loadmore]');
          if (nextLink) {
            loadmore.setAttribute('href', nextLink.getAttribute('href'));
            loadmore.classList.remove('is-loading');
          } else {
            loadmore.remove();
          }
        })
        .catch(function () { loadmore.classList.remove('is-loading'); });
    });
  }
})();
